export default __webpack_public_path__ + "src/assets/img_frame_313692.cfba80f156a49bc7dc80bbbbdaea3406.webp";